export const decodeUnicode = (s: string | undefined) => {
  if (!s) {
    return ''
  }

  return s.replaceAll(/\\u[0-9a-fA-F]{4}/g, m => String.fromCharCode(parseInt(m.slice(2), 16)))
}
